<template>
  <save-dialog
    :title="title"
    :dialog="dialog"
    :form="form"
    :route="route"
    :edit="true"
    :hasMore="false"
    :more="false"
    :bus="dialogBus"
    width="700px">
    <template slot="content">
      <v-expansion-panel>
        <v-expansion-panel-content v-for="(permissions, index) in modulePermissions" :key="`module-${index}`" :expanded="!index">
          <div slot="header">
            <v-layout row wrap align-center>
              <v-flex md9>
                <h5>Modulo: {{ permissions.name }}</h5>
              </v-flex>
              <v-flex md3>
                <div class="all-checkbox">
                  <v-checkbox
                    :input-value="areAllModuleItemsSelected(permissions)"
                    :indeterminate="hasSomeModuleItemsSelected(permissions)"
                    @change="toggleAllModuleItems(permissions)"
                    @click.stop>
                  </v-checkbox>
                </div>
              </v-flex>
            </v-layout>
          </div>
          <v-card>
            <v-card-text>
              <v-checkbox
                v-for="item in permissions.items"
                :key="item"
                :label="getPermissionName(item)"
                :value="item"
                v-model="permissionsSelected"></v-checkbox>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </template>
  </save-dialog>
</template>

<script>
import SaveDialog from '@/components/global/SaveDialog';
import saveDialogMixin from '@/mixins/saveDialog';
import EventBus from '@/event-bus';

export default {
  mixins: [
    saveDialogMixin,
  ],
  components: {
    SaveDialog,
  },
  created() {
    EventBus.$on('changePermissions', (userId) => {
      this.route = `users/${userId}/permissions`;
      EventBus.$emit('editItemPermissions', userId, false);
    });
  },
  destroyed() {
    EventBus.$off('changePermissions');
  },
  props: {
    permissions: {
      type: Array,
      default : () => [],
    },
  },
  data() {
    return {
      showName: 'Permisos',
      route: 'users/0/permissions',
      dialogBus: {
        created: 'createdPermissions',
        updated: 'updatedPemissions',
        modalOpened: 'modalOpenedPermissions',
        showMore: 'showMorePermissions',
        editItem: 'editItemPermissions',
        closeModal: 'closeModalPermissions',
        openRightDrawer: 'openRightDrawerPermissions',
      },
      modulePermissions: [
        {
          name: 'Usuarios',
          items: [
            'create_users',
            'see_users',
            'edit_users',
            'delete_users',
          ]
        },
        {
          name: 'Plantillas',
          items: [
            'create_templates',
            'see_templates',
            'edit_templates',
            'delete_templates',
          ],
        },
        {
          name: 'Respuestas',
          items: [
            'create_answer_templates',
            'see_answer_templates',
            'edit_answer_templates',
            'delete_answer_templates',
          ],
        },
        {
          name: 'Emails',
          items: [
            'create_company_emails',
            'see_company_emails',
            'edit_company_emails',
            'delete_company_emails',
          ],
        },
        {
          name: 'Agencias',
          items: [
            'create_agencies',
            'see_agencies',
            'edit_agencies',
            'delete_agencies',
          ],
        },
        {
          name: 'Chat Center',
          items: [
            'see_chat_center',
            'download_conversation',
            'send_conversation',
            'see_masked_contact_methods',
            'see_masked_account',
            'see_chat_center_whatsapp',
          ],
        },
        {
          name: 'Call Center',
          items: [
            'create_call_center',
            'see_call_center',
            'edit_call_center',
            'delete_call_center',
          ],
        },
        {
          name: 'Operadores - Call Center',
          items: [
            'see_call_center_operators',
          ],
        },
        {
          name: 'Campañas - Call Center',
          items: [
            'see_campaign_call_center',
            'connect_campaign_call_center',
            'can_edit_max_attempts',
            'can_edit_max_extensions',
            'numx_edit_call_center_algorithm',
            'numx_see_call_center_algorithm'
          ],
        },
        {
          name: 'Categorias de chat',
          items: [
            'create_chat_categories',
            'see_chat_categories',
            'edit_chat_categories',
            'delete_chat_categories',
          ],
        },
        {
          name: 'Agencias',
          items: [
            'create_agencies',
            'see_agencies',
            'edit_agencies',
            'delete_agencies',
          ],
        },
        {
          name: 'Flujo de canales',
          items: [
            'create_workflow_channels',
            'see_workflow_channels',
            'edit_workflow_channels',
            'delete_workflow_channels',
          ],
        },
        {
          name: 'Flujo de cobranza',
          items: [
            'create_workflow_notifications',
            'see_workflow_notifications',
            'edit_workflow_notifications',
            'delete_workflow_notifications',
            'edit_whatsapp_workflow',
          ],
        },
        {
          name: 'Plantillas de whatsapp',
          items: [
            'see_whatsapp_templates',
            'create_whatsapp_templates',
            'edit_whatsapp_templates',
            'delete_whatsapp_templates',
            'update_whatsapp_template_status',
          ],
        },
        {
          name: 'Clientes',
          items: [
            'see_customers',
            'create_contacts',
            'edit_contact',
            'call_contact',
            'see_masked_data',
            'see_customer_tracking',
          ],
        },
        {
          name: 'Dominios',
          items: [
            'create_domains',
            'see_domains',
            'edit_domains',
            'delete_domains',
          ],
        },
        {
          name: 'Campañas',
          items: [
            'create_campaigns',
            'see_campaigns',
            'delete_campaigns',
          ],
        },
        {
          name: 'Homologación de estados',
          items: [
            'see_company_status',
            'edit_company_status',
          ],
        },
        {
          name: 'Estados de contención',
          items: [
            'see_content_status_config',
            'edit_content_status_config',
          ],
        },
        {
          name: 'Descarga',
          items: [
            'create_report_downloads',
            'see_report_downloads',
          ],
        },
        {
          name: 'Reportes',
          items: [
            'see_reports',
          ],
        },
        {
          name: 'Datos invalidos',
          items: [
            'see_invalid_data',
          ],
        },
        {
          name: 'Cobranza',
          items: [
            'see_collection',
          ],
        },
        {
          name: 'Gestión diaria',
          items: [
            'see_daily_managements',
          ],
        },
        {
          name: 'Configuración del chat center',
          items: [
            'chat_config',
          ],
        },
        {
          name: 'Pagos',
          items: [
            'see_payments',
          ],
        },
        {
          name: 'Inteligencia de cobranza',
          items: [
            'see_quicksight_dashboards',
          ],
        },
        {
          name: 'Dashboards chat center',
          items: [
            'see_chat_center_dashboards',
          ],
        },
        {
          name: 'Ver grabaciones',
          items: [
            'see_recordings',
          ],
        },
        {
          name: 'Encuestas de satisfacción',
          items: [
            'create_survey',
            'edit_survey',
            'delete_survey',
          ],
        },
      ],
      permissionsSelected: [],
    };
  },
  computed: {
    form() {
      const obj = {};
      this.permissionsSelected.forEach((item) => {
        obj[item] = true;
      })
      return obj;
    },
  },
  methods: {
    clearForm() {
      Object.keys(this.form).forEach((key) => {
        this.form[key] = false;
      });
      this.$nextTick(() => {
        this.$validator.reset();
        this.errors.clear();
      });
    },
    getPermissionName(permission) {
      const index = this.permissions.findIndex(item => item.name === permission);
      if (index >= 0) {
        return this.permissions[index].display_name || 'Sin informacion';
      }
    },
    toggleAllModuleItems(modulePermission) {
      if (this.areAllModuleItemsSelected(modulePermission)) {
        this.permissionsSelected = this.permissionsSelected.filter(
          item => !modulePermission.items.includes(item)
        );
      } else {
        this.permissionsSelected = [...this.permissionsSelected, ...modulePermission.items].filter(
          (item, index, self) => self.indexOf(item) === index // To ensure uniqueness
        );
      }
    },
    areAllModuleItemsSelected(modulePermission) {
      return modulePermission.items.every(item => this.permissionsSelected.includes(item));
    },
    hasSomeModuleItemsSelected(modulePermission) {
      return modulePermission.items.some(item => this.permissionsSelected.includes(item));
    },
    searchElement() {
      this.axios.get(`/${this.route}?fields=${this.fields}`).then(({ data }) => {
        this.permissionsSelected = [...new Set(Object.keys(data))];
      });
      this.edit = true;
      this.dialog = true;
    },
  },
};
</script>

<style scoped>
  .all-checkbox >>> .input-group__details {
    display: none !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/user/PermissionsV2.vue